<div class="pr-4 pl-4 pt-4 pb-4 border highlight" (click)="clickCard()">
  <div fxLayout="row" fxLayoutAlign="start start">
    <div>
      <div fxLayout="row" fxLayoutAlign="start start" class="mt-1">
        <div style="width:205px">
          @if (typeName) {
            <span class="typeName">{{ typeName }}</span>
          }
          @if (typeNameTranslated) {
            <span class="typeName">{{ typeNameTranslated | translate }}</span>
          }
          @if (categoryName) {
            <span class="typeName vertical"> {{ categoryName }}</span>
          }
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start" class="mt-1">
        <span class="summary">{{ summary | stripHtml }}</span>
      </div>
    </div>
    @if (!!imageUrl || !!encodedImage) {
      <div>
        <img class="image-stream" src="{{ imageUrl }}" alt="data:image/jpeg;base64,{{ encodedImage }}">
      </div>
    } @else {
      <div  style="width:135px"></div>
    }
    @if (!!location) {
      <div class="ml-4">
        <div class="zoomToDocument" (click)="onZoomToDocument()"><i class="icon icon-zoom-to_location" style="font-size: 1.5rem"></i></div>
      </div>
    }
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between" class="posted mt-2">
    <div>
      <span>{{ postedDateTime }}</span>
    </div>
    <div>{{ postedElapsedTime }}</div>
  </div>

  @if (!!card?.workflowName && card?.dataset?.type === DatasetType.Alerts) {
    <div
      class="mt-2"
      style="width: calc(100% - 2rem)"
      fxLayout="row"
      fxLayoutAlign="start center"
      >
      <div class="workflow-color" [ngStyle]="{ 'background-color': card?.workflowColor }">&nbsp;</div>
      <div class="workflow-status">{{ card?.workflowName }}</div>
    </div>
  }

  @if (customFieldsSet) {
    <div>
      <div class="mt-3">
        <div
          topoDynamicForm
          [formView]="truncatedView"
          [schema]="card?.dataset?.schema"
          [document]="card?.document"
          [isEdit]="false"
          [controlCollection]="documentControls"
          [dataset]="dataset"
          [layerUId]="card?.layer?.uId"
          >
        </div>
      </div>
    </div>
  }
</div>

